import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartLine, faPlus, faSortDown, faSortUp} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import {useTranslation} from "react-i18next";
import {Consts} from "../pages/consts";
import {useContext} from "react";
import InitContext from "../pages/InitContext";

const SymptomTableHeader = ({ children, sortedSymptoms, onHandleShowSymptomsLineChart, sortConfig, onHandleSortChange,
                              selectSymptomModule, printView, onSetSelectSymptomModule, chartActionInToolbar = false}) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);

  const sortOptions = [
    { value: "startDate", label: t("date") },
    { value: "type", label: t("type") },
    { value: "term", label: t("symptom") },
  ];

  return (
    <div>
      <>
        {(children || !chartActionInToolbar) && (
          <header className="w3-container w3-center w3-padding-small">
            <div className="w3-display-container w3-padding-small">
              {children}
              {!chartActionInToolbar && sortedSymptoms?.length > 0 && (
                <div className="w3-display-right symptom-header-actions">
                  <button
                    type="button"
                    className="symptom-ui-button symptom-ui-button--icon symptom-ui-button--secondary"
                    onClick={() => onHandleShowSymptomsLineChart(null)}
                    aria-label={t("show_chart", { defaultValue: "Show chart" })}
                  >
                    <FontAwesomeIcon icon={faChartLine} />
                  </button>
                </div>
              )}
            </div>
          </header>
        )}
        <div className="w3-row w3-padding-small drugs-sort-row symptom-sort-row">
          <div className="w3-col s8">
            {sortedSymptoms?.length > 0 ? (
              <div className="symptom-sort-left-group">
                <label className="drugs-sort-label symptom-sort-label">
                  {t("sort_by")}:
                </label>
                <div className="flex-aligned-items symptom-sort-controls">
                  <Select
                    onChange={(selectedOption) => onHandleSortChange(selectedOption?.value)}
                    value={sortOptions?.find(
                      (option) => option?.value === sortConfig?.key,
                    )}
                    options={sortOptions}
                    placeholder={t("select")}
                    className="custom-select meds-sort-select symptom-sort-select"
                    classNamePrefix="meds-sort-select"
                    isSearchable={false}
                  />
                  <button
                    type="button"
                    className="symptom-ui-button symptom-ui-button--icon symptom-ui-button--secondary symptom-sort-order-button"
                    onClick={() => onHandleSortChange(sortConfig?.key)}
                    aria-label={t("toggle_sort_direction", { defaultValue: "Change sorting direction" })}
                  >
                    <FontAwesomeIcon
                      icon={sortConfig?.ascending ? faSortUp : faSortDown}
                      className="drugs-sort-icon symptom-sort-order-icon"
                    />
                  </button>
                </div>
              </div>
            ) : (
              <div className="w3-container"></div> /* empty container required to right align add button in case of an empty list  */
            )}
          </div>
          {( context?.role === Consts.HCP_PRESCRIBER || context?.role === Consts.PATIENT ) &&
            <div className="w3-col s4 w3-right-align symptom-sort-action-col">
              <div className="symptom-toolbar-actions">
                {chartActionInToolbar && sortedSymptoms?.length > 0 && !printView && (
                  <button
                    type="button"
                    className="symptom-ui-button symptom-ui-button--icon symptom-ui-button--secondary"
                    onClick={() => onHandleShowSymptomsLineChart(null)}
                    aria-label={t("show_chart", { defaultValue: "Show chart" })}
                  >
                    <FontAwesomeIcon icon={faChartLine} />
                  </button>
                )}
                {!selectSymptomModule && !printView && (
                  <button
                    type="button"
                    className="symptom-ui-button symptom-ui-button--primary responsive-button"
                    onClick={() => onSetSelectSymptomModule(true)}
                  >
                    <FontAwesomeIcon icon={faPlus}/>
                    <span className="symptom-ui-button__label">{t("add_new_symptom_report")}</span>
                  </button>
                )}
              </div>
            </div>
          }
        </div>
      </>
    </div>
  );
}

export default SymptomTableHeader;